import React from "react";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function KpkVoicenotes() {
  return (
    <div className="my-5">
      <div className="row row-cols-1 row-cols-md-2">
        <div className="col" style={{ display: "flex", alignItems: "center" }}>
          <h2 className="text-h-black">Author’s Voice-Notes</h2>
          {/* <br />
          <br /> */}
          {/* <p>
            Author of 'Serving Time: Pakistan's Prisons Through the Ages' Radha
            Shah speaks about the prison system of Khyber Pakhtunkhwa.
          </p> */}
        </div>
        <div className="col">
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/radha/Fata.mp3")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default KpkVoicenotes;
